import { Wrapper } from '@src/pages/error/Wrapper.tsx'
import { useTranslation } from 'react-i18next'
import { getCurrentBrowser, getDeviceOS, sensorFixData, useReplaceUrlHandler } from '@src/utils/sensor.ts'
import CameraIconSrc from '@static/media/images/permission.camera.svg'
import { useNavigate } from 'react-router-dom'
import { setLocalStorageItem } from '@src/utils/localStorage.ts'
import usePermission from '@src/hook/usePermission.tsx'

/** 카메라 권한 에러 페이지 */
export default function ErrorCameraSensor() {
  // 디바이스 OS와 브라우저에 따른 카메라 문제 해결 정보를 가져옴
  // 카메라 문제가 새로고침으로 해결 가능한지 여부를 확인
  // 페이지 새로고침 또는 특정 URL로 이동하는 함수를 가져옴
  // const cameraRefreshable = cameraFixData?.cameraRefreshable
  // const { replaceUrl }: any = useReplaceUrlHandler()

  const fixData = sensorFixData?.[getDeviceOS()]?.[getCurrentBrowser()]
  const { t } = useTranslation()
  const { requestAllPermission } = usePermission()
  const navigate = useNavigate()

  return (
    <div
      className={
        'bg-[#0E2153] w-full h-full flex flex-col items-center px-[2rem] pt-[4rem] overflow-y-scroll pb-[1rem]'
      }
    >
      <div className={'font-bold text-[2.4rem] text-white whitespace-pre-wrap text-center'}>
        {'카메라 센서 접근이\n거부되었습니다.'}
      </div>
      <div className={'text-white pt-[1.6rem] w-[26rem] text-center whitespace-pre-wrap'}>
        {'AR 콘텐츠 체험을 위해서는 반드시\n'}
        <span className={'text-[#CCFF00] font-bold'}>{'카메라 접근 권한을 허용하셔야'}</span> {'합니다.'}
      </div>

      <div className={'border-[0.5px] border-white  w-full mt-[3rem] mb-[3rem] max-w-[60rem]'}></div>

      <div className={'flex flex-row items-center gap-5 w-full max-w-[60rem]'}>
        <img src={CameraIconSrc} alt='' className='w-[5rem] h-[5rem] object-contain' />
        <div className={'flex flex-col'}>
          <div className={'text-white font-bold'}>카메라</div>
          <div className={'text-white font-light text-[1.4rem]'}>AR 콘텐츠 인식, 사진 또는 동영상 촬영</div>
        </div>
      </div>

      <div className={'text-[1.4rem] mt-[4rem] text-white w-full max-w-[60rem] '}>
        만약 새로고침을 해도 해결이 안되는 경우, 설정에서 브라우저의 카메라 권한이 항상 거부로 되어있는지 확인해주시기
        바랍니다.
      </div>

      <ol className={'text-[1.4rem] text-white w-full max-w-[60rem] mt-[3rem] list-decimal px-[1.5rem]'}>
        {fixData?.camera?.map((data: string, index: number) => (
          <li className={'mt-[0.5rem]'} key={index}>
            {t(data)}
          </li>
        ))}
      </ol>

      <div
        className={
          'w-full flex flex-row justify-center gap-5 mt-[4rem]  portrait:absolute portrait:bottom-[4rem] lg:absolute lg:bottom-[4rem] px-[2rem]'
        }
      >
        <button
          onClick={() => navigate('/home', { replace: true })}
          className={'py-[1.1rem] bg-white text-[#0C112A] rounded-small flex-1 max-w-[20rem] font-[500]'}
        >
          홈으로 가기
        </button>
        <button
          onClick={() => {
            requestAllPermission()
            setLocalStorageItem('movedFrom', true)
            navigate(-1)
          }}
          className={'py-[1.1rem] bg-[#FF61D3] text-white rounded-small flex-1 max-w-[20rem] font-[500]'}
        >
          새로고침하기
        </button>
      </div>
    </div>
  )
}
